import React, {useEffect, useRef, useState} from 'react';
import {NiceServiceDto, VerityType} from '../types/types';
import { getNiceRequest } from "../apis/user";
import {isMobile} from "react-device-detect";
import {Button} from '../components/Button';
import {nToast} from "../plugins/reactToast";

interface VerificationBtnProps {
    returnUrl: string;
    buttonText: string;
    verifyType: VerityType;
    checkboxChecked:boolean;
}


export const VerificationBtn = ({returnUrl, buttonText, verifyType, checkboxChecked}: VerificationBtnProps
) =>  {
    const [formData, setFormData] = useState<NiceServiceDto>()
    const [_isMobile, setMobile] = useState(false);
    const verificationFormRef = useRef<HTMLFormElement | null>(null);

    const handleClick = () => {
        if (checkboxChecked) {
            nToast('약관을 동의해주세요.');
            return;
        }

        getNiceRequest({
            returnUrl: _isMobile ? returnUrl : '/verification',
            verifyType: verifyType,
        })
            .then((r) => {
                if (r.data && r.data.payload) {
                    setFormData(r.data.payload);
                } else {
                    nToast('데이터가 없습니다.'); // 또는 에러 처리 방식에 따라 처리
                }
            })
            .catch((e) => {
                if (e.response && e.response.data && e.response.data.message) {
                    nToast(e.response.data.message);
                } else {
                    nToast('에러가 발생했습니다. 고객센터에 문의해주세요.');
                }
            });
    };

    useEffect(() => {
        setMobile(isMobile);
    }, [isMobile]);

    useEffect(() => {
        if (formData && verificationFormRef.current) {
            if (!_isMobile) {
                window.open("", "nice", "width=300, height=300, scrollbars=no, right=100, top=100");
            }
            verificationFormRef.current.submit(); // 폼 제출
        }
    }, [formData]);

    return (
        <>
            <div className={`w-full flex flex-col gap-y-2`}>
                <Button
                    className={`py-2 mt-4 text-white
                  ${checkboxChecked
                        ? 'bg-gray-300'
                        : 'bg-gray-900'
                    }`}
                    type="button" onClick={handleClick} text={buttonText}
                />
                <form
                    ref={verificationFormRef}
                    name="verification_form"
                    action="https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb"
                    target={_isMobile ? undefined : "nice"}
                >
                    <input type="hidden" name="m" value="service"/>
                    <input type="hidden" name="token_version_id" value={formData?.tokenVersionId}/>
                    <input type="hidden" name="enc_data" value={formData?.encData}/>
                    <input type="hidden" name="integrity_value" value={formData?.integrityValue}/>
                </form>
            </div>
        </>
    );
};
